import React from "react";

export default function VehicleLogList({ logs, onClose }) {
  // Group logs by date
  const groupedLogs = logs.reduce((acc, log) => {
    const date = new Date(log.history_date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    if (!acc[date]) acc[date] = [];
    acc[date].push(log);
    return acc;
  }, {});

  const formatTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="border p-4 mt-4 bg-gray-50 rounded-md">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Change History</h3>
        <button onClick={onClose} className="text-sm text-blue-600 hover:underline">
          Close
        </button>
      </div>

      {Object.entries(groupedLogs).map(([date, entries]) => (
        <div key={date} className="mb-6">
          <h4 className="font-semibold text-gray-700 mb-2">{date}</h4>
          <ul className="space-y-3">
            {entries.map((log, index) => {
              const user = log.history_user || "System";
              const changes = log.changes?.length
                ? log.changes
                : ["No relevant field changes."];

              return (
                <li
                  key={index}
                  className="bg-white p-3 rounded-md border shadow-sm text-sm text-gray-800"
                >
                  <div className="flex items-start gap-2">
                    <span className="text-xl">✏️</span>
                    <div>
                      <p className="mb-1 font-medium">
                        {formatTime(log.history_date)} {log.vehicle_name || "Vehicle"}, {user}
                      </p>
                      <ul className="list-disc list-inside text-gray-700">
                        {changes.map((change, i) => (
                          <li key={i} className="ml-2">({change})</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}
